import { MenuItems } from "../pages/menuItems";
import { Page } from "../../Components/pages/objects/page";

const Header: Page['header'] = {
    menu: {
        links: MenuItems
    }
}

export default Header;